import { combineReducers } from "redux";
import authReducer from "./Auth/reducer";
import mastersReducer from "./Masters/reducer";
import servicesReducer from "./Services/reducer";
import serviceCategoriesReducer from "./ServiceCategories/reducer";
import recordsReducer from "./Records/reducer";
import usersReducer from "./Users/reducer";
import pageContentsReducer from "./PageContent/reducer";
import massagesReducer from "./Messages/reducer";
import chatReducer from "./Chat/reducer";
import galleryReducer from "./Gallery/reducer";

export default combineReducers({
  auth: authReducer,
  users: usersReducer,
  masters: mastersReducer,
  services: servicesReducer,
  records: recordsReducer,
  pageContents: pageContentsReducer,
  serviceCategories: serviceCategoriesReducer,
  messages: massagesReducer,
  chat: chatReducer,
  gallery: galleryReducer,
});
